import React from "react";
import "../styles/CountdownCircle.css";

interface CountdownCircleProps {
  secondsRemaining: number;
  totalSeconds: number;
  isPaused: boolean;
  label: string;
}

const CountdownCircle: React.FC<CountdownCircleProps> = ({
  secondsRemaining,
  totalSeconds,
  isPaused,
  label,
}) => {
  const radius = 50;
  const circumference = 2 * Math.PI * radius;

  // Ensure totalSeconds is not 0 to avoid division by zero
  const progressPercentage =
    totalSeconds > 0 ? secondsRemaining / totalSeconds : 0;
  const strokeDashoffset = circumference * (1 - progressPercentage);

  let statusText = "";
  if (label === "NOT_STARTED") {
    statusText = "not started";
  } else if (isPaused) {
    statusText = "paused";
  } else if (label === "FINISHED" || (secondsRemaining <= 0 && totalSeconds > 0)) {
    statusText = "finished";
  }

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  return (
    <div className="countdown-container">
      <svg className="countdown-svg" viewBox="0 0 120 120">
        <circle
          className="countdown-background"
          cx="60"
          cy="60"
          r={radius}
        />
        <circle
          className={`countdown-progress ${isPaused ? "paused" : ""}`}
          cx="60"
          cy="60"
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
        />
      </svg>
      <div className="countdown-text">
        <span className="countdown-number">{formatTime(secondsRemaining)}</span>
        {!statusText && (
          <span className="countdown-label">{label}</span>
        )}
      </div>
      {statusText && (
        <div className="status-overlay">
          <span className="status-text">{statusText}</span>
        </div>
      )}
    </div>
  );
};

export default CountdownCircle; 